import { all } from "redux-saga/effects";
import {
  createNewPasswordWatcher,
  forgotPasswordWatcher,
  logoutWatcher,
  portalLoginWatcher,
  resetPasswordWatcher,
  watchLoginWorker,
} from "./authSaga";
import {
  stateListWatcher,
  districtListWatcher,
  cityListWatcher,
  divisionistWatcher,
  activeMenuWatcher,
  privacyPloicyWatcher,
  termsConditionWatcher,
} from "./commonSaga";
import {
  fieldForceCreateWatcher,
  fieldForceDeleteWatcher,
  fieldForceDesignationListWatcher,
  fieldForceDetailWatcher,
  fieldForceEditWatcher,
  fieldForceEnableDisableWatcher,
  fieldForcListWatcher,
  fetchReportingManagerListWatcher,
  fetchHeadQuaterListWatcher,
  fieldForceVersionListWatcher,
  fieldForceVersionDetailWatcher,
  fetchDesignationListWatcher,
  fetchDesignationDetailWatcher,
  fieldForceDesignationCreateWatcher,
  fieldForceDesignationEditWatcher,
  fieldForceDesignationDeleteWatcher,
  fieldForceDesignationVersionListWatcher,
  fieldForceDesignationVersionDetailWatcher,
  fieldForceLinkEmpListWatcher,
  fieldForceLinkEmployeeWatcher,
  fieldForceHeadQuarterListWatcher,
  fieldForceHeadQuarterDetailsWatcher,
  fieldForceHeadQuarterCreateWatcher,
  fieldForceHeadQuarterEditWatcher,
  fieldForceHeadQuarterVersionListWatcher,
  fieldForceHeadQuarterVersionDetailWatcher,
  headQuarterEnableDisableWatcher,
  fieldForceheadQuarterDeleteWatcher,
  fetchFieldForceAdminWatcher,
  fieldForceAdminVerifyWatcher,
  fieldForceAdminEditWatcher,
  reportingDesignationListWatcher,
  fetchFieldForceAdminOverrideWatcher,
  subordinatesListWatcher,
  reportingManagersListWatcher,
  updateSubordinatesReportingManagersWatcher,
  ffCustomersListWatcher,
  updateCustomersReportingManagerWatcher,
} from "./fieldForceSaga";
import { faqListWatcher } from "./faqSaga";
import { initialDataLoadWatcher } from "./indexSaga";
import {
  packingTypeWatcher,
  productAddDoctorListWatcher,
  productAddPharmacyLisWatcher,
  productCreateWatcher,
  productDeleteWatcher,
  productDetailWatcher,
  productDoctorAddWatcher,
  productDoctorListWatcher,
  productDoctorOfferReqestWatcher,
  productEditWatcher,
  productEnableDisableWatcher,
  productHeadQuaterListWatcher,
  productListWatcher,
  productPharmacyAddWatcher,
  productPharmacyListWatcher,
  productPharmacyOfferReqestWatcher,
  productVersionDetailWatcher,
  productVersionWatcher,
  productViewPharmacyListWatcher,
  productViewSoctorListWatcher,
  vendorDivisionListWatcher,
} from "./productSaga";
import {
  PrivacyPolicyEditWatcher,
  accountSettingWatcher,
  createSettingWatcher,
  privaypolicySettingWatcher,
  supportCreateWatcher,
  termsConditionSettingEditWatcher,
  termsConditionSettingWatcher,
  viewSettingWatcher,
} from "./settingSaga";
import {
  CustomerSendMailWatcher,
  customerApproveRejectWatcher,
  customerDetailWatcher,
  customerListWatcher,
  customerVersionDetailWatcher,
  customerVersionHistoryListWatcher,
  fetchHeadQuarterListWatcher,
  subcriberRequestDetailWatcher,
  subscriberRequestListWatcher,
  CustomerDivisionListWatcher,
  CustomerDivisionFeildForceListWatcher,
  CustomerAddDivisionWatcher,
  CustomerDeleteDivisionWatcher,
  productOfferRequestListWatcher,
  productOfferRequestViewWatcher,
  productOfferRequestApproveRejectWatcher,
  productOffersListWatcher,
  productOfferRemoveWatcher,
  productOfferDivisionProductsWatcher,
  productOfferAddWatcher,
  productOfferEditWatcher,
  pharmacyProductOfferRequestListWorkerWatcher,
  pharmacyProductOfferRequestViewWatcher,
  productOfferRequestApproveAllWatcher,
  productOfferRequestRejectAlWatcher,
  pharmacyProductOfferRequestApproveAllWatcher,
  pharmacyProductOfferRequestRejectAlWatcher,
  pharmacyroductOfferRequestApproveRejectWatcher,
  pharmacyProductOffersListWatcher,
  pharmacyProductOfferEditWatcher,
  customerPharmacyDetailWatcher,
  customerPharmacyListWatcher,
  subcriberRequestPharmacyDetaillWatcher,
  subscriberRequestPharmacyListWatcher,
  updateDoctorTypeWatcher,
  updatePharmacyTypeWatcher,
  onboardPharmacyProductOffersListWatcher,
  onboardDoctorProductOffersListWatcher,
  customerAddProductListWatcher,
  customerAddProductOffersListWatcher,
  addCustomerProductWatcher,
  addPharmacyProductWatcher,
  customerSubscriberRequestListWatcher,
  customerSubcriberRequestDetailWatcher,
} from "./customerSaga";
import {
  distributorCreateWatcher,
  distributorDetailWatcher,
  distributorEnableDisableWatcher,
  distributorLinkWatcher,
  distributorListWatcher,
  distributorOnboardingListWatcher,
  dropdivisionListWatcher,
  editDistributorDistrictsWatcher,
  fetchDistributorDistrictsWatcher,
  listDistributorLinkWatcher,
  sendMailWatcher,
} from "./distributorSaga";
import {
  manageOrderDetailWatcher,
  manangeOrderListWatcher,
} from "./manageOrderSaga";
import {
  cfaCreateWatcher,
  cfaDeleteWatcher,
  cfaDetailWatcher,
  cfaEditWatcher,
  cfaEnableDisableWatcher,
  cfaListWatcher,
  cfaSendMailWatcher,
  cfaVersionDetailWatcher,
  cfaVersionWatcher,
  fetchCfaDistributorListWatcher,
  fetchCfaHeadQuaterListWatcher,
} from "./cfaSaga";
import {
  fetchPermissionListWatcher,
  fetchPermissionRoleListWatcher,
  fetchRoleListWatcher,
  fetchRolePermissionListWatcher,
  superUserCreateWatcher,
  superUserDeleteWatcher,
  superUserDetailWatcher,
  superUserEditWatcher,
  superUserListWatcher,
  superUserPermissionListWatcher,
  superUserRoleCreateWatcher,
  superUserRoleDeleteWatcher,
  superUserRoleDetailWatcher,
  superUserRoleEditWatcher,
  superUserRoleListWatcher,
  superUserRoleVersionDetailWatcher,
  superUserRoleVersionListWatcher,
  superUserVersionDetailWatcher,
  superUserVersionListWatcher,
} from "./superUserSaga";
import {
  analyticalReportDownloadWatcher,
  dashboardWatcher,
  graphCardWatcher,
} from "./dashboardSaga";
import {
  analyticsStatusWatcher,
  analyticsWatcher,
  distributorAnalyticsListWatcher,
  divisionListWatcher,
  doctorListWatcher,
  fieldForceListWatcher,
  headquaterListWatcher,
  pharmacyListWatcher,
  productListAnalyticsWatcher,
} from "./analyticsSaga";
import {
  createDivisionWatcher,
  createDoctorWatcher,
  createPharmacyWatcher,
  distributorBulkVerifyWatcher,
  distributorCsvUploadWatcher,
  divisionDetailManufacturerWatcher,
  divisionListManufacturerWatcher,
  doctorBulkVerifyWatcher,
  doctorCsvUploadWatcher,
  doctorDivViewUploadWatcher,
  doctorDivisionListUploadWatcher,
  editDivisionWatcher,
  enableDisableDivisionWatcher,
  fetchreimbursementListWatcher,
  ffDivisionListUploadWatcher,
  fieldForceBulkVerifyWatcher,
  fieldForceCsvUploadWatcher,
  pharmacyBulkUploadWatcher,
  pharmacyCsvUploadWatcher,
  pharmacyDivViewUploadWatcher,
  pharmacyDivisionListUploadWatcher,
  productBulkVerifyWatcher,
  productCsvUploadWatcher,
  productDivisionListUploadWatcher,
  productDivisionViewUploadWatcher,
} from "./divisionSaga";
import {
  generatePoInvoiceWatcher,
  poCsvDownloadWatcher,
  poCsvSendMailWatcher,
  poDistributorListWatcher,
  poListWatcher,
  poOfferTypeListWatcher,
  poStateListWatcher,
  poViewWatcher,
} from "./poSagas";
import {
  aiVerifiedInvoiceListWatcher,
  aiVerifiedInvoiceyDetailWatcher,
  flagAiVerifiesInvoicesWatcher,
  flaggedInvoiceDetailWatcher,
  flaggedInvoiceListWatcher,
  invoiceVerifiedListWatcher,
  invoiceVerifyDetailWatcher,
  invoiceVerifyListWatcher,
  pendingInvoiceDetailWatcher,
  pendingInvoiceListWatcher,
  pendingInvoiceRejectWatcher,
  pendingInvoiceVerifyWatcher,
  productBatchPricingWatcher,
  rejectedInvoiceDetailWatcher,
  rejectedInvoiceListWatcher,
  upodateProductPtrWatcher,
  verifiedInvoiceDetailWatcher,
  verifiedInvoiceListWatcher,
} from "./invoiceVerificationSaga";
import {
  customerVerifyDetailWatcher,
  customerVerifyListWatcher,
  verifyReportWatcher,
} from "./customerVerificationSaga";

export default function* rootSaga() {
  yield all([
    initialDataLoadWatcher(),
    logoutWatcher(),
    stateListWatcher(),
    districtListWatcher(),
    cityListWatcher(),
    divisionistWatcher(),
    watchLoginWorker(),
    packingTypeWatcher(),
    productListWatcher(),
    productDetailWatcher(),
    productHeadQuaterListWatcher(),
    productDoctorListWatcher(),
    fieldForcListWatcher(),
    fieldForceDetailWatcher(),
    fieldForceDeleteWatcher(),
    fieldForceEnableDisableWatcher(),
    faqListWatcher(),
    fieldForceCreateWatcher(),
    fieldForceEditWatcher(),
    fetchFieldForceAdminWatcher(),
    fieldForceAdminVerifyWatcher(),
    fieldForceAdminEditWatcher(),
    fieldForceDesignationListWatcher(),
    fetchReportingManagerListWatcher(),
    fetchHeadQuaterListWatcher(),
    fieldForceHeadQuarterListWatcher(),
    fieldForceHeadQuarterDetailsWatcher(),
    fieldForceHeadQuarterCreateWatcher(),
    fieldForceHeadQuarterEditWatcher(),
    fieldForceHeadQuarterVersionListWatcher(),
    fieldForceHeadQuarterVersionDetailWatcher(),
    fieldForceheadQuarterDeleteWatcher(),
    headQuarterEnableDisableWatcher(),
    supportCreateWatcher(),
    fieldForceVersionListWatcher(),
    fieldForceVersionDetailWatcher(),
    productCreateWatcher(),
    productEditWatcher(),
    productEnableDisableWatcher(),
    productDeleteWatcher(),
    productVersionWatcher(),
    productVersionDetailWatcher(),
    vendorDivisionListWatcher(),
    fetchDesignationListWatcher(),
    fetchDesignationDetailWatcher(),
    fieldForceDesignationCreateWatcher(),
    fieldForceDesignationEditWatcher(),
    fieldForceDesignationDeleteWatcher(),
    fieldForceDesignationVersionListWatcher(),
    fieldForceDesignationVersionDetailWatcher(),
    fieldForceLinkEmpListWatcher(),
    fieldForceLinkEmployeeWatcher(),
    reportingDesignationListWatcher(),
    customerListWatcher(),
    customerDetailWatcher(),
    listDistributorLinkWatcher(),
    subscriberRequestListWatcher(),
    subcriberRequestDetailWatcher(),
    customerVersionHistoryListWatcher(),
    customerVersionDetailWatcher(),
    customerApproveRejectWatcher(),
    distributorListWatcher(),
    distributorDetailWatcher(),
    distributorEnableDisableWatcher(),
    distributorLinkWatcher(),
    manangeOrderListWatcher(),
    manageOrderDetailWatcher(),
    activeMenuWatcher(),
    cfaListWatcher(),
    cfaCreateWatcher(),
    cfaEditWatcher(),
    cfaDetailWatcher(),
    cfaVersionWatcher(),
    cfaVersionDetailWatcher(),
    fetchCfaHeadQuaterListWatcher(),
    fetchCfaDistributorListWatcher(),
    cfaEnableDisableWatcher(),
    cfaDeleteWatcher(),

    createSettingWatcher(),
    viewSettingWatcher(),

    superUserListWatcher(),
    superUserDetailWatcher(),
    superUserCreateWatcher(),
    superUserEditWatcher(),
    superUserDeleteWatcher(),
    superUserVersionListWatcher(),
    superUserVersionDetailWatcher(),
    fetchPermissionListWatcher(),
    superUserPermissionListWatcher(),
    superUserRoleDetailWatcher(),

    superUserRoleListWatcher(),
    superUserRoleCreateWatcher(),
    superUserRoleEditWatcher(),
    superUserRoleDeleteWatcher(),
    superUserRoleVersionListWatcher(),
    superUserRoleVersionDetailWatcher(),
    fetchRolePermissionListWatcher(),

    dashboardWatcher(),
    portalLoginWatcher(),

    privacyPloicyWatcher(),
    termsConditionWatcher(),
    createNewPasswordWatcher(),
    forgotPasswordWatcher(),
    resetPasswordWatcher(),
    fetchDistributorDistrictsWatcher(),
    editDistributorDistrictsWatcher(),

    analyticalReportDownloadWatcher(),
    graphCardWatcher(),

    analyticsWatcher(),
    analyticsStatusWatcher(),
    divisionListWatcher(),
    productListAnalyticsWatcher(),
    fieldForceListWatcher(),
    distributorAnalyticsListWatcher(),
    pharmacyListWatcher(),
    doctorListWatcher(),
    headquaterListWatcher(),
    fetchRoleListWatcher(),
    divisionListManufacturerWatcher(),
    divisionDetailManufacturerWatcher(),
    productDivisionListUploadWatcher(),
    ffDivisionListUploadWatcher(),
    doctorDivisionListUploadWatcher(),
    pharmacyDivisionListUploadWatcher(),
    doctorDivViewUploadWatcher(),
    pharmacyDivViewUploadWatcher(),
    fetchreimbursementListWatcher(),
    createDivisionWatcher(),
    editDivisionWatcher(),
    enableDisableDivisionWatcher(),
    fetchHeadQuarterListWatcher(),
    reportingManagersListWatcher(),
    updateSubordinatesReportingManagersWatcher(),
    updateCustomersReportingManagerWatcher(),
    ffCustomersListWatcher(),
    CustomerSendMailWatcher(),
    poListWatcher(),
    poCsvDownloadWatcher(),
    poStateListWatcher(),
    poDistributorListWatcher(),
    poOfferTypeListWatcher(),
    generatePoInvoiceWatcher(),
    poCsvSendMailWatcher(),
    accountSettingWatcher(),
    privaypolicySettingWatcher(),
    termsConditionSettingWatcher(),
    PrivacyPolicyEditWatcher(),
    termsConditionSettingEditWatcher(),
    invoiceVerifyListWatcher(),
    invoiceVerifyDetailWatcher(),
    customerVerifyListWatcher(),
    customerVerifyDetailWatcher(),

    verifyReportWatcher(),
    productBulkVerifyWatcher(),
    productCsvUploadWatcher(),
    productPharmacyListWatcher(),
    productViewSoctorListWatcher(),
    productViewPharmacyListWatcher(),
    productDoctorOfferReqestWatcher(),
    productPharmacyOfferReqestWatcher(),
    fieldForceCsvUploadWatcher(),
    fieldForceBulkVerifyWatcher(),
    distributorCsvUploadWatcher(),
    distributorBulkVerifyWatcher(),
    doctorCsvUploadWatcher(),
    doctorBulkVerifyWatcher(),
    pharmacyCsvUploadWatcher(),
    pharmacyBulkUploadWatcher(),
    createDoctorWatcher(),
    createPharmacyWatcher(),
    sendMailWatcher(),
    dropdivisionListWatcher(),
    distributorCreateWatcher(),
    distributorOnboardingListWatcher(),
    cfaSendMailWatcher(),
    fetchFieldForceAdminOverrideWatcher(),
    subordinatesListWatcher(),
    CustomerDivisionListWatcher(),
    CustomerDivisionFeildForceListWatcher(),
    CustomerAddDivisionWatcher(),
    CustomerDeleteDivisionWatcher(),
    productOfferRequestListWatcher(),
    pharmacyProductOfferRequestListWorkerWatcher(),
    pharmacyProductOfferRequestViewWatcher(),
    addCustomerProductWatcher(),
    productOfferRequestApproveAllWatcher(),
    productOfferRequestRejectAlWatcher(),
    productAddDoctorListWatcher(),
    productAddPharmacyLisWatcher(),
    productPharmacyAddWatcher(),
    productDoctorAddWatcher(),
    pharmacyProductOfferRequestApproveAllWatcher(),
    pharmacyProductOfferRequestRejectAlWatcher(),
    pharmacyroductOfferRequestApproveRejectWatcher(),
    customerSubcriberRequestDetailWatcher(),
    customerSubscriberRequestListWatcher(),
    pharmacyProductOffersListWatcher(),
    pharmacyProductOfferEditWatcher(),
    productOfferRequestViewWatcher(),
    addPharmacyProductWatcher(),
    productOfferRequestApproveRejectWatcher(),
    productOffersListWatcher(),
    updateDoctorTypeWatcher(),
    onboardDoctorProductOffersListWatcher(),
    onboardPharmacyProductOffersListWatcher(),
    customerAddProductListWatcher(),
    customerAddProductOffersListWatcher(),
    updatePharmacyTypeWatcher(),
    poViewWatcher(),
    productOfferRemoveWatcher(),
    productOfferDivisionProductsWatcher(),
    customerPharmacyListWatcher(),
    customerPharmacyDetailWatcher(),
    subscriberRequestPharmacyListWatcher(),
    subcriberRequestPharmacyDetaillWatcher(),
    productOfferAddWatcher(),
    productOfferEditWatcher(),
    invoiceVerifiedListWatcher(),

    aiVerifiedInvoiceListWatcher(),
    aiVerifiedInvoiceyDetailWatcher(),
    verifiedInvoiceListWatcher(),
    verifiedInvoiceDetailWatcher(),
    flaggedInvoiceListWatcher(),
    flaggedInvoiceDetailWatcher(),
    pendingInvoiceListWatcher(),
    pendingInvoiceDetailWatcher(),
    rejectedInvoiceListWatcher(),
    rejectedInvoiceDetailWatcher(),
    pendingInvoiceVerifyWatcher(),
    pendingInvoiceRejectWatcher(),
    productBatchPricingWatcher(),
    upodateProductPtrWatcher(),
    flagAiVerifiesInvoicesWatcher(),
  ]);
}
